import { gql } from '@apollo/client';
import { ReviewDocumentsManagerFields } from '../../ratification/fragments';

export const InvoiceReviewDocumentsFields = gql`
  fragment InvoiceReviewDocumentsFields on InvoiceType {
    reviewDocumentsManager {
      ...ReviewDocumentsManagerFields
    }
  }
  ${ReviewDocumentsManagerFields}
`;

export default InvoiceReviewDocumentsFields;
